import type { Nullable } from '@protector/utils/types';
import type { StaticPointType } from '@protector/entities/static-point/constants';
import type { Station } from '@protector/entities/station/models';
import type { FixedPointInfo } from 'pages/fixed-points/fixed-points.models';

export const StaticPointsDrawerTypes = {
  TOGGLE_DRAWER: '[Static Points Drawer] Toggle Visibility',
  SELECT_TEMPLATE: '[Static Points Drawer] Select Template',
  EDIT_STATION: '[Static Points Drawer] Edit Station',
  CLEAR_SELECTED_STATION: '[Static Points Drawer] Clear Selected Station',
  SELECT_TRAPVIEW: '[Static Points Drawer] Select Trapview',
  CLEAR_SELECTED_TRAPVIEW: '[Static Points Drawer] Clear Selected Trapview'
} as const;

export const ToggleDrawer = (visible: boolean, type: Nullable<StaticPointType> = null) => {
  return {
    type: StaticPointsDrawerTypes.TOGGLE_DRAWER,
    payload: { visible, type }
  };
};

export const SelectTemplateDrawer = (template: Nullable<FixedPointInfo>) => {
  return {
    type: StaticPointsDrawerTypes.SELECT_TEMPLATE,
    payload: template
  };
};

export const EditStationDrawer = (station: Station) => {
  return {
    type: StaticPointsDrawerTypes.EDIT_STATION,
    payload: station
  };
};

export const ClearSeletectedStationDrawer = () => {
  return {
    type: StaticPointsDrawerTypes.CLEAR_SELECTED_STATION
  };
};

export const SelectTrapviewDrawer = () => {
  return {
    type: StaticPointsDrawerTypes.SELECT_TRAPVIEW
  };
};

export const ClearSelectedTrapviewDrawer = () => {
  return {
    type: StaticPointsDrawerTypes.CLEAR_SELECTED_TRAPVIEW
  };
};
